import axios from 'axios';
import API from './api';
const userService = {
    login(Account, Password) {
        return new Promise((resolve, reject) => {
            axios.post(`${API.localhost}/v1/user/login`, {
                phone: Account,
                password: Password
            }).then(res => {
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        });
    }
}
export { userService };